import "./Panel.css";

function buildPanelClassName({
  className,
  footer,
  footerEnd,
  hasStructuredChrome,
  header,
  headerEnd,
  padded,
  scroll,
  toolbar
}) {
  return [
    "panel",
    padded ? "panel--padded" : "",
    scroll ? "panel--scroll" : "",
    hasStructuredChrome ? "panel--structured" : "",
    header || headerEnd ? "panel--with-header" : "",
    toolbar ? "panel--with-toolbar" : "",
    footer ? "panel--with-footer" : "",
    footerEnd ? "panel--with-footer-end" : "",
    className
  ]
    .filter(Boolean)
    .join(" ");
}

function renderPanelHeader(header, headerEnd) {
  if (!header && !headerEnd) {
    return null;
  }

  return (
    <header class="panel-header">
      <span>{header}</span>
      {headerEnd ? <span class="panel-header-end">{headerEnd}</span> : null}
    </header>
  );
}

function renderPanelFooter(footer, footerEnd, footerClassName, footerEndClassName) {
  if (!footer && !footerEnd) {
    return null;
  }

  return (
    <div class={`panel-footer${footerClassName ? ` ${footerClassName}` : ""}`}>
      {footer ? (
        <div class="panel-footer-content">
          {typeof footer === "string" ? <p class="panel-footer-text">{footer}</p> : footer}
        </div>
      ) : null}
      {footerEnd ? (
        <div class={`panel-footer-end${footerEndClassName ? ` ${footerEndClassName}` : ""}`}>
          {footerEnd}
        </div>
      ) : null}
    </div>
  );
}

export function Panel({
  as: Tag = "section",
  children,
  className = "",
  padded = false,
  scroll = false,
  header = null,
  headerEnd = null,
  toolbar = null,
  footer = null,
  footerClassName = "",
  footerEnd = null,
  footerEndClassName = "",
  ...props
}) {
  const hasStructuredChrome = header || headerEnd || toolbar || footer || footerEnd;
  const panelClassName = buildPanelClassName({
    className,
    footer,
    footerEnd,
    hasStructuredChrome,
    header,
    headerEnd,
    padded,
    scroll,
    toolbar
  });

  return (
    <Tag class={panelClassName} {...props}>
      {renderPanelHeader(header, headerEnd)}
      {toolbar ? <div class="panel-toolbar">{toolbar}</div> : null}
      {hasStructuredChrome ? <div class="panel-body">{children}</div> : children}
      {renderPanelFooter(footer, footerEnd, footerClassName, footerEndClassName)}
    </Tag>
  );
}
